import Axios from "axios";
import { TextShortcode } from "@/models/TextShortcode";

let cache: TextShortcode[] | null = null;

class TextShortcodeService {
    static async getAll(): Promise<TextShortcode[]> {
        if (cache) return cache;
        const response = await Axios.get("Configuration/TextShortcodes");
        const raw: any[] = typeof response.data === 'string'
            ? (response.data ? JSON.parse(response.data) : [])
            : (response.data ?? []);
        cache = raw.map(item => ({
            code: item.code ?? item.Code ?? '',
            expansion: item.expansion ?? item.Expansion ?? '',
            category: item.category ?? item.Category,
            sortOrder: item.sortOrder ?? item.SortOrder ?? 0,
        }));
        return cache;
    }

    static invalidateCache(): void {
        cache = null;
    }
}

export default TextShortcodeService;
